import {
  allKindProduct,
  CALENDAR_LOCAL_ES,
  dataSharingTexts,
  DUO,
  FUSION,
  ONLY_MOBILE,
  ONLY_PHONE,
  toolTipDataRoaming,
  TRIO,
  UNLIMITED,
} from "@/constants/constants";
import { convertNCleanOtherLabel } from "@/utils/dataHandler";
import { getUrl, sumArray } from "@/utils/commonUtils";
import {
  changeDashFormatToSlash,
  changeSecondsToMinutesFormat,
  getJustDateFromDateTimeShort,
  substractOneMonthToDate,
} from "@/utils/momentFacilities";
import { getTotalDaysBetween } from "@/utils/utils";
import {
  iconTabsLabelUsageDetail,
  usageStructure,
  kindProductStructure,
} from "@/constants/setupBasics";
import { transformMeasureUnits } from "@/utils/dataHandlers/Transformers";
import { getBundleFromMobileProductId, getLinesMobileFromHiredProducts, getLinesPhoneFromHiredProducts, getTvsFromHiredProducts } from "@/utils/dataHandlers/ProductDataHandler";
import { getProductNameOfferingByType } from "@/utils/dataHandlers/CatalogueDataHandler";
import { TEXT_TYPES_CODES } from "@/constants/catalogue";

export const getNewHaveThisDetUsage = (
  haveThisDetUsage,
  specificDetailedUsage,
  currentSlide,
  kindProduct
) => {
  const newHaveThisDetUsage = { ...haveThisDetUsage };
  if (kindProduct === allKindProduct.mobile) {
    switch (currentSlide) {
      case 0:
        newHaveThisDetUsage.voice = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 1:
        newHaveThisDetUsage.data = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 2:
        newHaveThisDetUsage.sms = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 3:
        newHaveThisDetUsage.others = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 99:
        newHaveThisDetUsage.expenses = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      default:
        newHaveThisDetUsage.voice = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(0);
        break;
    }
  } else if (kindProduct === allKindProduct.phone) {
    switch (currentSlide) {
      case 0:
        newHaveThisDetUsage.voice = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 1:
        newHaveThisDetUsage.others = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 99:
        newHaveThisDetUsage.expenses = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      default:
        newHaveThisDetUsage.voice = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(0);
        break;
    }
  } else if (kindProduct === allKindProduct.tv) {
    switch (currentSlide) {
      case 0:
        newHaveThisDetUsage.others = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      case 99:
        newHaveThisDetUsage.expenses = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      default:
        newHaveThisDetUsage.voice = specificDetailedUsage;
        newHaveThisDetUsage.alreadyRequest.push(0);
        break;
    }
  }
  return newHaveThisDetUsage;
};

export const getSpecificDetailedUsage = (
  currentSlide,
  detailedUsages,
  kindProduct
) => {
  let specificDetailedUsage = null;
  if (kindProduct === allKindProduct.mobile) {
    switch (currentSlide) {
      case 0:
        specificDetailedUsage = detailedUsages.voice;
        break;
      case 1:
        specificDetailedUsage = detailedUsages.data;
        break;
      case 2:
        specificDetailedUsage = detailedUsages.sms;
        break;
      case 3:
        specificDetailedUsage = detailedUsages.others;
        break;
      case 99:
        const voiceWithPrice = detailedUsages.voice.filter(
          (item) => item.price > 0
        );
        const dataWithPrice = detailedUsages.data.filter(
          (item) => item.price > 0
        );
        const smsWithPrice = detailedUsages.sms.filter(
          (item) => item.price > 0
        );
        const othersWithPrice = detailedUsages.others.filter(
          (item) => item.price > 0
        );
        specificDetailedUsage = [
          ...dataWithPrice,
          ...voiceWithPrice,
          ...smsWithPrice,
          ...othersWithPrice,
        ];

        break;
      default:
        specificDetailedUsage = detailedUsages.voice;
        break;
    }
  } else if (kindProduct === allKindProduct.phone) {
    switch (currentSlide) {
      case 0:
        specificDetailedUsage = detailedUsages.voice;
        break;
      case 1:
        specificDetailedUsage = detailedUsages.others;
        break;
      case 99:
        const voiceWithPrice = detailedUsages.voice.filter(
          (item) => item.price > 0
        );
        const othersWithPrice = detailedUsages.others.filter(
          (item) => item.price > 0
        );

        specificDetailedUsage = [...voiceWithPrice, ...othersWithPrice];
        break;
      default:
        specificDetailedUsage = detailedUsages.voice;
        break;
    }
  } else if (kindProduct === allKindProduct.tv) {
    switch (currentSlide) {
      case 0:
        specificDetailedUsage = detailedUsages.others;
        break;
      case 99:
        const othersWithPrice = detailedUsages.others.filter(
          (item) => item.price > 0
        );

        specificDetailedUsage = othersWithPrice;
        break;
      default:
        specificDetailedUsage = detailedUsages.others;
        break;
    }
  }
  return specificDetailedUsage;
};

export const getSpecificDetailedUsageToShow = (
  currentSlide,
  detailedUsages,
  kindProduct,
  lineProductId = 99,
) => {
  let specificDetailedUsage = null;
  //productId = 99 es que coge todas
  if(lineProductId === detailedUsages?.productId || lineProductId === 99) {
    if (kindProduct === allKindProduct.mobile) {
      switch (currentSlide) {
        case 0:
          specificDetailedUsage = detailedUsages.voice;
          break;
        case 1:
          specificDetailedUsage = detailedUsages.data;
          break;
        case 2:
          specificDetailedUsage = detailedUsages.sms;
          break;
        case 3:
          specificDetailedUsage = detailedUsages.others;
          break;
        case 99:
          specificDetailedUsage = detailedUsages.expenses;
          break;
        default:
          specificDetailedUsage = detailedUsages.voice;
          break;
      }
    } else if (kindProduct === allKindProduct.phone) {
      switch (currentSlide) {
        case 0:
          specificDetailedUsage = detailedUsages.voice;
          break;
        case 1:
          specificDetailedUsage = detailedUsages.others;
          break;
        case 99:
          specificDetailedUsage = detailedUsages.expenses;
          break;
        default:
          specificDetailedUsage = detailedUsages.voice;
          break;
      }
    } else if (kindProduct === allKindProduct.tv) {
      switch (currentSlide) {
        case 0:
          specificDetailedUsage = detailedUsages.others;
          break;
        case 99:
          specificDetailedUsage = detailedUsages.expenses;
          break;
        default:
          specificDetailedUsage = detailedUsages.others;
          break;
      }
    } else if (!kindProduct) {
      switch (currentSlide) {
        case 99:
          specificDetailedUsage = detailedUsages.expenses;
          break;
        default:
          specificDetailedUsage = detailedUsages.voice;
          break;
      }
    }
  }

  //aqui hacer el filtrado por ProductId

  return specificDetailedUsage;
};

export const getUsageType = (currentSlide, kindProduct) => {
  let usageType = null;
  if (kindProduct === allKindProduct.mobile) {
    switch (currentSlide) {
      case 0:
        usageType = "Llamadas";
        break;
      case 1:
        usageType = "Datos";
        break;
      case 2:
        usageType = "Mensajes";
        break;
      case 3:
        usageType = "Otros";
        break;
      default:
        usageType = "Llamadas";
        break;
    }
  } else if (kindProduct === allKindProduct.phone) {
    switch (currentSlide) {
      case 0:
        usageType = "Llamadas";
        break;
      case 1:
        usageType = "Otros";
        break;
      default:
        usageType = "Llamadas";
        break;
    }
  } else if (kindProduct === allKindProduct.tv) {
    usageType = "Otros";
  }
  return usageType;
};

export const getDateBonuTokenization = (bonu) => {
  if (bonu) {
    return bonu.validForEnd;
  }
  return null;
};
export const isBonu1gbTokenization = (bonu) => {
  if (
    bonu &&
    bonu.tokenization &&
    bonu.maxValue !== UNLIMITED &&
    !bonu.fb &&
    !bonu.free
  ) {
    return true;
  }
  return false;
};
export const isBonuUnlimitedTokenization = (bonu) => {
  if (
    bonu &&
    bonu.tokenization &&
    bonu.maxValue === UNLIMITED &&
    !bonu.fb &&
    !bonu.free
  ) {
    return true;
  }
  return false;
};

export const getTabLabelsForDetailedUsage = (kindProduct) => {
  const tabLabels = [];

  let usageInfo;
  let id = 0;
  // Loop over usageStructure keys to get every detailed usage for the product
  Object.keys(usageStructure).forEach((usageKey) => {
    if (
      (kindProduct !== "phone" && kindProduct !== "tv") ||
      (kindProduct === "phone" && usageKey !== "data" && usageKey !== "sms") ||
      (kindProduct === "tv" &&
        usageKey !== "data" &&
        usageKey !== "voice" &&
        usageKey !== "sms")
    ) {
      usageInfo = usageStructure[usageKey];
      tabLabels.push({
        id,
        value: usageInfo.tabText,
        usageKey,
        icon: iconTabsLabelUsageDetail[usageKey],
      });
      id += 1;
    }
  });

  return tabLabels;
};
export const groupUsagesByDate = (usages) => {
  const usagesGrouped = {};

  usages.forEach((usage) => {
    const dateString = `day_${usage.dateUsage.split(" ")[0]}`;
    if (!usagesGrouped[dateString]) {
      usagesGrouped[dateString] = [];
    }
    usagesGrouped[dateString].push(usage);
  });

  return usagesGrouped;
};
export const getUsageListItems = (
  usageArray,
  type,
  priceGreaterThan0 = false
) => {
  const itemArray = [];
  let topText = "";
  let bottomText = "";
  let toolTip = "";
  let call = "";
  let icon = "Movil";
  usageArray.forEach((usage) => {
    if (!priceGreaterThan0 || usage.price !== 0) {
      switch (type) {
        case "data":
          topText = `${transformMeasureUnits(usage.unit, usage.used)}`;
          bottomText = usage.roaming && usage.serviceType;
          toolTip = usage.roaming && toolTipDataRoaming;
          icon = "Datos";
          break;
        case "voice":
          topText = usage.numberDestination;
          bottomText = `${
            usage.dateUsage.split(" ")[1]
          } - ${changeSecondsToMinutesFormat(usage.used)}`;
          call = usage.type;
          icon = "Movil";
          break;
        case "sms":
          topText = usage.numberDestination;
          bottomText = `${usage.dateUsage.split(" ")[1]}`;
          icon = "Sms";
          break;
        case "others":
          topText = convertNCleanOtherLabel(usage.label);
          bottomText = `${usage.dateUsage.split(" ")[1]}`;
          break;
        default:
          topText = usage.numberDestination;
          bottomText = `${
            usage.dateUsage.split(" ")[1]
          } - ${transformMeasureUnits(usage.unit, usage.used)}`;
      }
      const itemObject = {};
      itemObject.icon = icon;
      itemObject.topText = topText;
      itemObject.bottomText = bottomText;
      itemObject.toolTip = toolTip;
      itemObject.price = usage.price.toFixed(2);
      itemObject.roaming = usage.roaming || false;
      itemObject.roamingTeaxt = usage.serviceType || "";
      itemObject.link = "";
      itemObject.call = call;

      itemArray.push(itemObject);
    }
  });
  return itemArray;
};

export const getListArrayForDetailedUsage = (
  detailedUsages,
  kindProduct,
  priceGreaterThan0 = false
) => {
  const totalArray = [];
  if (!detailedUsages) {
    return null;
  }

  // Loop over usageStructure keys to get every detailed usage for the product
  Object.keys(usageStructure).forEach((usageKey) => {
    const listArray = [];
    if (
      detailedUsages[usageKey] &&
      ((kindProduct !== "phone" && kindProduct !== "tv") ||
        (kindProduct === "phone" &&
          usageKey !== "data" &&
          usageKey !== "sms") ||
        (kindProduct === "tv" &&
          usageKey !== "data" &&
          usageKey !== "voice" &&
          usageKey !== "sms"))
    ) {
      const usagesGroupe = groupUsagesByDate(detailedUsages[usageKey]);
      Object.keys(usagesGroupe).forEach((groupeKey) => {
        const dateString = groupeKey.replace("day_", "");
        // const title = getJustDateFromDateTime(dateString);
        const title = changeDashFormatToSlash(dateString);
        const listArrayObject = {
          title,
          itemArray: getUsageListItems(
            usagesGroupe[groupeKey],
            usageKey,
            priceGreaterThan0
          ),
        };
        listArray.push(listArrayObject);
        return null;
      });
      listArray.moreElements = detailedUsages[usageKey].moreElements;
      listArray.pageNumber = detailedUsages[usageKey].pageNumber;
      totalArray.push(listArray);
    }
  });
  return totalArray;
};

export const getPeriods = (cycleInfo, productId, period) => {
  if (cycleInfo.length === 0) {
    return null;
  }

  // Encuentra el ciclo correspondiente al productId
  const cycle =
    cycleInfo.find((pc) => pc.productId === productId) || cycleInfo[0];
  if (!cycle) {
    return null;
  }

  // Función para formatear la fecha en el formato deseado ("DD de MMM")
  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split("-").map(Number);
    const padZero = (num) => String(num).padStart(2, "0");
    return `${padZero(day)}/${padZero(month)}/${String(year).slice(-2)}`;
  };

  // Función para obtener el nombre corto del mes
  const getMonthNameShort = (month) => {
    const months = [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ];
    return months[parseInt(month, 10) - 1];
  };

  const periodsOptions = [
    {
      label: `${formatDate(cycle.startCycle)} - ${formatDate(cycle.endCycle)}`,
      value: 0,
    },
  ];

  let defaultPeriod = [
    {
      label: `${formatDate(cycle.startCycle)} - ${formatDate(cycle.endCycle)}`,
      value: 0,
    },
  ];

  let [startDay, startMonth, startYear] = cycle.startCycle
    .split("-")
    .map(Number);
  let [endDay, endMonth, endYear] = cycle.endCycle.split("-").map(Number);

  for (let i = 0; i < 11; i++) {
    // Restamos un mes a las fechas
    if (startMonth === 1) {
      startMonth = 12;
      startYear--;
    } else {
      startMonth--;
    }
    if (endMonth === 1) {
      endMonth = 12;
      endYear--;
    } else {
      endMonth--;
    }

    periodsOptions.push({
      label: `${formatDate(
        `${startDay}-${startMonth}-${startYear}`
      )} - ${formatDate(`${endDay}-${endMonth}-${endYear}`)}`,
      value: i + 1,
    });

    if (parseInt(period, 10) === i + 1) {
      defaultPeriod = [
        {
          label: `${formatDate(
            `${startDay}-${startMonth}-${startYear}`
          )} - ${formatDate(`${endDay}-${endMonth}-${endYear}`)}`,
          value: period,
        },
      ];
    }
  }

  return {
    periods: periodsOptions,
    default: defaultPeriod,
  };
};

export const getDataValuesFromBonus = (bonus) => {
  if (bonus && bonus.length > 0) {
    const values = bonus.map((element) => {
      return element.maxValue;
    });

    return sumArray(values);
  }
  return null;
};

export const hasDataSharing = (usages, period) => {
  let dataSharing = false;
  if (usages) {
    usages.forEach((usage) => {
      if (period !== undefined && period !== null) {
        if (!dataSharing && usage.kindProduct === allKindProduct.mobile) {
          if (Array.isArray(usage.period) && usage.period.length > 0 && usage.period[period]?.data?.currentShared !== undefined && usage.period[period]?.data?.currentShared !== null && usage.period[period]?.data?.currentShared !== -1) {
            dataSharing = true;
          }
        }
      } else {
        if (!dataSharing && usage?.kindProduct === allKindProduct.mobile) {
          if (usage.data.currentShared !== undefined && usage.data.currentShared !== null && usage.data.currentShared !== -1) {
            dataSharing = true;
          }
        }
      }
    });
  }
  return dataSharing;
};

export const hasDataSharingActive = (usages) => {
  let dataSharing = false;
  if (usages) {
    usages.forEach((usage) => {
      if (!dataSharing && usage?.kindProduct === allKindProduct.mobile) {
        if (usage?.data?.currentShared >= 0) {
          dataSharing = true;
        }
      }
    });
  }
  return dataSharing;
};

export const hasDataLimited = (usages) => {
  // UNLIMITED
  let dataUnlimited = false;
  if (usages) {
    usages.forEach((usage) => {
      if (usage?.kindProduct === allKindProduct.mobile) {
        if (usage?.data?.maxValue > 0) {
          dataUnlimited = true;
        }
      }
    });
  }
  return dataUnlimited;
};

/* AUXILIAR FUNCTIONS FOR DATA SHARING */
export const getDataSharingInfo = (usages, urlLibrary) => {
  let maxValueShared = -1;
  let currentShareUsed = -1;
  let numberOfLines = 0;
  let sumBonus = 0;
  const sharedPhonesArray = [];
  // Search all over usages to find which phones have DataSharing activated
  // const link2use = getUrl('usage', urlLibrary);
  usages.forEach((usage) => {
    if (usage?.kindProduct === allKindProduct.mobile) {
      if (usage?.data?.currentShared !== -2) {
        sumBonus = getDataValuesFromBonus(usage.data.bonus);
        if (maxValueShared === -1 && currentShareUsed === -1) {
          maxValueShared = usage.data.maxValue;
          currentShareUsed = usage.data.currentShared;
        }

        // Adapt shared phones to ItemList Array
        sharedPhonesArray.push({
          iconWrapperClass: "rounded_icon",
          icon: kindProductStructure.mobile.icon,
          topText: usage.phoneNumber,
          bottomText: `Aporta ${transformMeasureUnits("kb", sumBonus)}`,
          rightText: transformMeasureUnits(usage.data.unit, usage.data.current),
          // link: `${link2use}/movil/${usage.productId}`,
          productId: usage.productId,
        });

        numberOfLines += 1;
      }
    }
  });

  const donutProps = {
    label: {
      color: "grey4",
      value: dataSharingTexts.donutText,
    },
    ringsList: [
      {
        consumedData: currentShareUsed,
        maxValueData: maxValueShared,
        strokeColor: "",
        badge: false,
      },
    ],
  };

  const sharedPhones = [
    {
      itemArray: sharedPhonesArray,
    },
  ];

  return {
    sharedPhones,
    donutProps,
    numberOfLines,
    currentShared: currentShareUsed,
    maxValueShared,
  };
};

export const getBonusUsageFromUsage = (usages) => {
  if (usages) {
    const bonusList = [];
    usages.forEach((usage) => {
      if (usage && usage.data && usage.data.bonus) {
        bonusList.push(usage.data.bonus);
      }
    });
    return [...new Set([].concat(...bonusList))];
  }
  return null;
};
export const getBonusUsagePayFromUsage = (usages) => {
  if (usages) {
    const bonus = getBonusUsageFromUsage(usages);
    const bonusPay = bonus.filter((x) => x.fb === false && x.free === false);
    return bonusPay;
  }
  return null;
};

export const getDateBonusTokenization = (bonus) => {
  if (bonus && bonus.length > 0) {
    return bonus[0].validForEnd;
  }
  return null;
};

export const getAccumulatedUsageByProductId = (
  accumulatedUsages,
  productId
) => {
  let referencedAccumulatedUsage = null;
  if (accumulatedUsages) {
    accumulatedUsages.forEach((currentAccumulatedUsage) => {
      if (currentAccumulatedUsage.productId === productId) {
        referencedAccumulatedUsage = currentAccumulatedUsage;
      }
    });
    return referencedAccumulatedUsage;
  }
  return null;
};

export const haveGotAllMyAccumulatedUsages = (products, accumulatedUsages) => {
  const accumulatedByProduct = {
    allAccumulatedUsaged: [],
    areAllAccumulated: true,
    accumulatedNotObtained: [],
  };

  if (products) {
    products.forEach((product) => {
      const currentAccumulated = getAccumulatedUsageByProductId(
        accumulatedUsages,
        product.productId
      );
      if (currentAccumulated) {
        accumulatedByProduct.allAccumulatedUsaged.push(currentAccumulated);
      } else {
        accumulatedByProduct.areAllAccumulated = false;
        accumulatedByProduct.accumulatedNotObtained.push(product);
      }
      return null;
    });
  }
  /* return all accumulated of the product and if we have all accumulated */
  return accumulatedByProduct;
};
export const getExtraUsageForEachTab = (tabs, accumulated) => {
  return tabs.map((tab) => {
    return { ...tab, extra: accumulated[tab.usageKey].extra > 0 };
  });
};
export const getPpuUsageByProductId = (accumulatedUsages, productId) => {
  if (accumulatedUsages[0] && productId) {
    const usage = getAccumulatedUsageByProductId(accumulatedUsages, productId);
    if (usage) {
      const ppu = usage.data.ppu.status;
      return ppu;
    }
  }
  return null;
};
export const getDataSharedUsageByProductId = (accumulatedUsages, productId) => {
  if (accumulatedUsages[0]) {
    const usage = getAccumulatedUsageByProductId(accumulatedUsages, productId);
    if (usage) {
      const { currentShared } = usage.data;
      const isDataShared = currentShared >= 0;
      return isDataShared;
    }
  }
  return null;
};

export const getPpuIdByProductId = (accumulatedUsages, productId) => {
  if (accumulatedUsages[0] && productId) {
    const usage = getAccumulatedUsageByProductId(accumulatedUsages, productId);
    if (usage) {
      const ppu = usage.data.ppu.productId;
      return ppu;
    }
  }
  return null;
};
export const getProductBySharedPhones = (hiredProducts, sharedPhones) => {
  let product = null;
  if (sharedPhones && sharedPhones.length > 0) {
    const { itemArray } = sharedPhones[0];
    if (itemArray && itemArray.length > 0) {
      const { productId } = itemArray[0];
      product = getBundleFromMobileProductId(hiredProducts, productId);
    }
  }
  return product;
};

export const getAlreadyRequestDetailed = (
  detailedUsages,
  currentSlide,
  kindProduct
) => {
  const newHaveThisDetUsage = { ...detailedUsages };
  if (kindProduct === allKindProduct.mobile) {
    switch (currentSlide) {
      case 0:
      case 1:
      case 2:
      case 3:
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      default:
        newHaveThisDetUsage.alreadyRequest.push(0);
        break;
    }
  } else if (kindProduct === allKindProduct.phone) {
    switch (currentSlide) {
      case 0:
      case 1:
        newHaveThisDetUsage.alreadyRequest.push(currentSlide);
        break;
      default:
        newHaveThisDetUsage.alreadyRequest.push(0);
        break;
    }
  } else if (kindProduct === allKindProduct.tv) {
    newHaveThisDetUsage.alreadyRequest.push(0);
  }
  return newHaveThisDetUsage;
};

export const getDatePeriod = (cycleInfo, productId, date) => {
  if (cycleInfo.length === 0) {
    return null;
  }

  const cycle = cycleInfo.find((pc) => pc.productId === productId);
  if (!cycle) {
    return null;
  }

  let start = cycle.startCycle;
  let end = cycle.endCycle;

  let period = 0;

  for (let i = 0; i < 11; i++) {
    start = substractOneMonthToDate(start);
    end = substractOneMonthToDate(end);
    const startCompare = changeFrontFormatToServerFormat(
      substractOneMonthToDate(start)
    );
    const endCompare = changeFrontFormatToServerFormat(
      substractOneMonthToDate(end)
    );
    if (date >= startCompare && date <= endCompare) {
      period = i + 3;
    }
  }

  return period;
};

export const getOptionsToUsages = (hiredProducts, catalogueProductOffering, orionProduct) => {
  let options = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.forEach((product, index) => {
      if (
        (product.productType === FUSION ||
          product.productType === TRIO ||
          product.productType === DUO ||
          product.productType === ONLY_MOBILE ||
          product.productType === ONLY_PHONE) &&
        product.poId &&
        catalogueProductOffering[product.poId]
      ) {
        let name = getProductNameOfferingByType({
          catalogueProductOffering,
          textType: TEXT_TYPES_CODES.ORDINARY,
          poId: product.poId,
        });
        if (!name) {
          name = getProductNameOfferingByType({
          catalogueProductOffering,
          textType: TEXT_TYPES_CODES.SHORT_EXPLANATORY,
          poId: product.poId,
        });
        }
        const label = name?.[0]?.text ?? `Producto${index}`;
        const option = { label, value: index };
        options.push(option);
      }
    });
  }
  if (options.length > 1) {
    options.unshift({ label: "Todos los consumos", value: 99 });
  }
  return options;
};


export const getOptionsToUsagesExtra = (detailedUsage, hiredProducts, catalogueProductOffering) => {
  let options = [{ label: "Todos", value: 99 }];
  console.log(detailedUsage, hiredProducts)
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.forEach((product, index) => {
      if (
        (product.productType === FUSION ||
          product.productType === TRIO ||
          product.productType === DUO ||
          product.productType === ONLY_MOBILE ||
          product.productType === ONLY_PHONE) &&
        product.poId &&
        catalogueProductOffering[product.poId]
      ) {
        const name = getProductNameOfferingByType({
          catalogueProductOffering,
          textType: TEXT_TYPES_CODES.ORDINARY,
          poId: product.poId,
        });
        const option = { label: name[0].text, value: product.productId };
        options.push(option);
      }
    });
  }
  return options;
};

export const getOptionsToLineDetailedUsages = (hiredProducts, catalogueProductOffering) => {
  let options = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.forEach((product, index) => {
      if (
        (product.productType === FUSION ||
          product.productType === TRIO ||
          product.productType === DUO ||
          product.productType === ONLY_MOBILE ||
          product.productType === ONLY_PHONE) &&
        product.poId &&
        catalogueProductOffering[product.poId]
      ) {
        const name = getProductNameOfferingByType({
          catalogueProductOffering,
          textType: TEXT_TYPES_CODES.ORDINARY,
          poId: product.poId,
        });
        const option = { label: name[0].text, value: index };
        options.push(option);
      }
    });
  }
  if (options.length > 1) {
    options.unshift({ label: "Todos los consumos", value: 99 });
  }
  return options;
};

export const getStartAndEndDateByProductsCycleInfoAndPeriod = (
  productsCycleInfo,
  period
) => {
  let startDate = "";
  let endDate = "";
  if (Array.isArray(productsCycleInfo) && productsCycleInfo.length > 0) {
    startDate = new Date(
      `${productsCycleInfo[0].startCycle.split("-")[2]}-${
        productsCycleInfo[0].startCycle.split("-")[1]
      }-${productsCycleInfo[0].startCycle.split("-")[0]}`
    );
    endDate = new Date(
      `${productsCycleInfo[0].endCycle.split("-")[2]}-${
        productsCycleInfo[0].endCycle.split("-")[1]
      }-${productsCycleInfo[0].endCycle.split("-")[0]}`
    );

    if (period !== 0) {
      startDate = new Date(startDate.setMonth(startDate.getMonth() - period));
      endDate = new Date(endDate.setMonth(endDate.getMonth() - period));
    }
  }
  return { startDate, endDate };
};

export const getPeriodsToUsages = (productsCycleInfo, period, isPrepaid = false) => {
  let periodUsages = [
    {
      mainTitle: ``,
      subTitle: ``,
      maxValue: -1,
      current: "",
      days: "",
      isClosed: true,
    },
  ];
  if (Array.isArray(productsCycleInfo) && productsCycleInfo.length > 0) {
    const { startDate, endDate } =
      getStartAndEndDateByProductsCycleInfoAndPeriod(productsCycleInfo, period);
    if (startDate && endDate) {
      const totalDaysBetween = getTotalDaysBetween(startDate, endDate);
      const remainingDays = productsCycleInfo[0].remainingDays;
      const daysUntilEndCycle = totalDaysBetween - remainingDays;
      const day = startDate.getDate();
      const endDay = endDate.getDate();
      const monthNumberStart = startDate.getMonth();
      const monthNumberEnd = endDate.getMonth();
      const monthNameStart = CALENDAR_LOCAL_ES.monthNames[monthNumberStart];
      const monthNameEnd = CALENDAR_LOCAL_ES.monthNames[monthNumberEnd];
      const monthDays = new Date(
        startDate.getFullYear(),
        monthNumberStart + 1,
        0
      ).getDate();
      let infoDays = '';
      if (remainingDays !== undefined && remainingDays !== null && period === 0) {
        if (remainingDays === 1) {
          infoDays = `Queda ${remainingDays} día`;
        } else {
          infoDays = `Quedan ${remainingDays} días`;
        }
      }
      periodUsages = [
        {
          mainTitle: `${day} ${monthNameStart}${isPrepaid ? ' -\u00A0' : ''}`,
          subTitle: `${endDay} ${monthNameEnd}`,
          maxValue: period === 0 ? monthDays : -1,
          current: period === 0 ? daysUntilEndCycle : "",
          days: period === 0 ? remainingDays : "",
          isClosed: period !== 0,
          infoDays: period === 0 ? infoDays : '',
        },
      ];
    }
  }
  return periodUsages;
};

export const getBillingCycle = (issueDay, productsCycleInfo) => {
  if (issueDay && productsCycleInfo && Array.isArray(productsCycleInfo) && productsCycleInfo.length > 0) {
    const [day, month, year] = issueDay.split("/");
    if (Array.isArray(productsCycleInfo) && productsCycleInfo.length > 0) {
      const [cycle] = productsCycleInfo;
      const [startDay] = cycle.startCycle.split("-");
      const [endDay] = cycle.endCycle.split("-");
  
      const cycleStartDate = new Date(year, month - 3, startDay);
      const cycleEndDate = new Date(year, month - 2, endDay);
    
      const startDate = cycleStartDate.toLocaleDateString('es-ES');
      const endDate = cycleEndDate.toLocaleDateString('es-ES');
    
      return {
        startDate,
        endDate
      };
    }
  }
  return null;
};

export const getKindProductFromHiredProducts = (hiredProducts) => {
  let kindProduct = '';
  const linesMobile = getLinesMobileFromHiredProducts(hiredProducts);
  if (linesMobile && Array.isArray(linesMobile) && linesMobile.length > 0) {
    kindProduct = allKindProduct.mobile;
  } else {
    const linesPhone = getLinesPhoneFromHiredProducts(hiredProducts)
    if (linesPhone && Array.isArray(linesPhone) && linesPhone.length > 0) {
      kindProduct = allKindProduct.phone;
    } else {
      const tvs = getTvsFromHiredProducts(hiredProducts)
      if (tvs && Array.isArray(tvs) && tvs.length > 0) {
        kindProduct = allKindProduct.tv;
      }
    }
  }
  return kindProduct;
}